module.exports = __webpack_public_path__ + "img/App.a5346083.png";